"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
require("./App.css");
var widgetHelper_1 = require("./helpers/widgetHelper");
var Loader_1 = __importDefault(require("./components/Loader"));
var EventConstants_1 = require("./constants/EventConstants");
var react_2 = require("react");
var sendEventBridge_1 = require("./eventUtils/sendEventBridge");
var styleHelpers_1 = require("./helpers/styleHelpers");
var App = function (props) {
    var _a = (0, react_1.useState)(false), widgetLoaded = _a[0], setWidgetLoaded = _a[1];
    var _b = (0, react_1.useState)(false), widgetError = _b[0], setWidgetError = _b[1];
    var widgetUrl = (0, widgetHelper_1.getWidgetUrl)(props.lob, props.pageName, props.requestorSource, null, null, null, props.customUri);
    function initiateTask() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        window.addEventListener('message', eventHandler);
                        (0, widgetHelper_1.attachToWindow)(props);
                        if (!(0, widgetHelper_1.widgetNotPresent)())
                            return [2 /*return*/];
                        return [4 /*yield*/, (0, widgetHelper_1.fetchHTML)(props === null || props === void 0 ? void 0 : props.customUri)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    var eventHandler = function (event) {
        if (event.data && event.data.eventName && event.data.trigger != 'Heartbeat') {
            performEventAction === null || performEventAction === void 0 ? void 0 : performEventAction(event.data.eventName, event.data);
        }
    };
    var performEventAction = function (eventName, eventData) {
        var enableBackdrop = true;
        switch (eventName) {
            case EventConstants_1.EVENTS.PAGE_LOADED: {
                (0, sendEventBridge_1.sendToWidget)({});
                setWidgetLoaded(true);
                if (!sendEventBridge_1.loaded)
                    props === null || props === void 0 ? void 0 : props.eventListener(eventData);
                (0, sendEventBridge_1.setLoaded)();
                props.args && (0, widgetHelper_1.sendArgsToWidget)(props.args);
                break;
            }
            case EventConstants_1.EVENTS.ENABLE_BACKDROP: {
                (0, widgetHelper_1.isBackdrop)(enableBackdrop, eventData);
                break;
            }
            case EventConstants_1.EVENTS.DISABLE_BACKDROP: {
                (0, widgetHelper_1.isBackdrop)(!enableBackdrop, eventData);
                break;
            }
            case EventConstants_1.EVENTS.WIDGET_ERROR: {
                setWidgetError(true);
                break;
            }
            case EventConstants_1.EVENTS.SAVED_ADDRESS: {
                (0, widgetHelper_1.fetchCityfromPincode)(eventData.data, props);
                break;
            }
            case EventConstants_1.EVENTS.SUBMIT: {
                props === null || props === void 0 ? void 0 : props.eventListener(eventData);
                (0, sendEventBridge_1.sendToWidget)({
                    eventName: "CtoWCloseModal",
                    eventType: "closeAddressForm"
                });
                break;
            }
            default: {
                props === null || props === void 0 ? void 0 : props.eventListener(eventData);
                break;
            }
        }
    };
    (0, react_2.useEffect)(function () {
        initiateTask();
        return function () {
            (0, widgetHelper_1.removeWidgetFromBody)();
            window.removeEventListener('message', eventHandler);
        };
    }, []);
    (0, react_2.useEffect)(function () {
        window.removeEventListener('message', eventHandler);
        window.addEventListener('message', eventHandler);
    }, [props.mountCount]);
    return (widgetError ?
        (0, jsx_runtime_1.jsx)("div", { id: 'iFrame-root', style: widgetError ? { display: 'block' } : { display: 'none' }, children: (0, jsx_runtime_1.jsx)("div", { id: "widget-mask", style: styleHelpers_1.widgetDialog, children: (0, jsx_runtime_1.jsx)("iframe", { title: "omniwidget", allow: "geolocation fullscreen *", id: "widget-frame-web", referrerPolicy: "", src: widgetUrl, style: styleHelpers_1.widgetStyleBase }) }) })
        :
            (0, jsx_runtime_1.jsxs)("div", { id: "container-root", style: widgetError ? { display: 'none' } : {}, children: [(0, jsx_runtime_1.jsx)("div", { id: 'widget-mask' }), (0, jsx_runtime_1.jsx)("div", { id: "react-native-web-app", style: widgetLoaded ? { display: 'block' } : { display: 'none' } }), (0, jsx_runtime_1.jsx)("div", { className: 'htmlLoader' }), (0, jsx_runtime_1.jsx)("div", { style: widgetLoaded ? { display: 'none' } : { display: 'block' }, children: (0, jsx_runtime_1.jsx)(Loader_1.default, {}) })] }));
};
exports.default = App;
